export default __webpack_public_path__ + "static/media/Jeff at Ouachita Trail.99239cbb.jpg";